import {
  DEALER_DETAILS,
  BOOKING_DETAILS,
  CURRENT_STEP,
  CAR_INFOS,
  CAR_KILO,
  SERVICES,
  CODE_PAS_FOR_ANNUALSERVICE,
  SERVICES_SELECTED,
  COMMENT_SERVICES,
  PERSONEL_INFOS,
  PREMIUM_SERVICES_DSVALET,
  SELECTED_PREMIUM_SERVICES,
  LIST_PREMIUM_SERVICES,
  EDITMODE,
  DIALOG_CONFIRMATION_CHANGE_STEP,
  ATTACHMENTID,
  FILES,
  DATELIMIT,
  SELECTED_LAT,
  SELECTED_LONG,
  FILTER_DEALERS_BY,
  FILTER_BY_CHOICE,
  DEALERS_FILTRED,
  IDRDVLEADS
} from '../actions/types'

const defaultState =
//   {
//     dealer: {
//       iD: 16062,
//       SelfReception: true,
//       geoID: '0000003275',
//       name: 'GARAGE MICHEL MALLE SA',
//       adress: '13 RUE DU STADE',
//       city: 'GUIPEL',
//       zip: '35440',
//       position: {
//         lat: 48.2994181,
//         lng: -1.7170127
//       }
//     },
//     booking: { hour: '08:00', date: '09/09/2019', happy: '5' },
//     step: 6,
//     car: {
//       Mileage: 333,
//       SerialNumber: 'VF32AKFWA47747165',
//       HasServiceContract: true,
//       BrandLabel: 'Citroën',
//       BrandCode: null,
//       ModelCode: '1PT1A5',
//       ModelLabel: '206 -  5 portes',
//       EnergyLabel: '2,0L HDi 136ch FAP - boîte manuelle',
//       MotorCode: 'S15',
//       MotorLabel: '1,4L 75ch - boite manuelle',
//       Lcdv: '1PT1A5US1500A061',
//       Registration: ''
//     },
//     kilo: { contratService: false, kilometrage: '333', carStep: 3 },
//     service: [],
//     SelectedServices: [
//       {
//         interventionId: 2580,
//         interventionLabel: 'Freinage',
//         codeFamilyForfait: 'FCT0040,FCT0041',
//         Image: '/Media/P/fr-FR/Intervention/2580.png',
//         forfaits: [
//           {
//             Code: 'FCT0040',
//             Title: 'Freins avant',
//             Image: '/Media/P/fr-FR/Functions/FCT0040.jpg',
//             Order: 7,
//             Promo: false,
//             VinRequired: false,
//             isConstructeur: false,
//             hasForfait: true,
//             Price: false,
//             SubFunctionList: [
//               {
//                 Code: 'FCT0040',
//                 ForfaitList: [
//                   {
//                     Libelle: 'FORFAIT €COEXPERT Disques et plaquettes frein avant',
//                     ParentRef: '',
//                     Items: [
//                       {
//                         Libelle: '',
//                         IsAnyPgInBrr: true,
//                         IsTypeInternet: true,
//                         DateFin: '/Date(1609455600000)/',
//                         DateDebut: '/Date(1550444400000)/',
//                         Nature: 'Eurorepar',
//                         Niveau: '19',
//                         Prix: 518,
//                         TypeDi: 'FORFAIT',
//                         TypeFdz: 'Standard',
//                         RefTPAff: '42055A',
//                         RefCT: '42055AER01',
//                         Ref: '42055AER01FR0101',
//                         TypeOperation: null
//                       }
//                     ],
//                     Comments: [
//                       {
//                         Order: 1,
//                         Text: 'Prestation réalisée avec des pièces de rechange spécialement conçues pour votre véhicule.'
//                       },
//                       {
//                         Order: 2,
//                         Text: 'Ces pièces de qualité sont testées et validées selon un cahier des charges établi par l’ingénierie Peugeot.'
//                       },
//                       {
//                         Order: 3,
//                         Text: 'Remplacement du kit de deux disques et quatre plaquettes de freins avant.'
//                       },
//                       {
//                         Order: 4,
//                         Text: "Un contrôle d'usure des disques et plaquettes de freins est effectué à chaque révision."
//                       },
//                       {
//                         Order: 5,
//                         Text: 'Ce contrôle est inclus dans notre offre pré-contrôle technique.'
//                       }
//                     ],
//                     Operations: null
//                   },
//                   {
//                     Libelle: 'FORFAIT €COEXPERT Plaquettes de frein avant',
//                     ParentRef: '',
//                     Items: [
//                       {
//                         Libelle: '',
//                         IsAnyPgInBrr: true,
//                         IsTypeInternet: true,
//                         DateFin: '/Date(1609455600000)/',
//                         DateDebut: '/Date(1550444400000)/',
//                         Nature: 'Eurorepar',
//                         Niveau: '12',
//                         Prix: 238,
//                         TypeDi: 'FORFAIT',
//                         TypeFdz: 'Standard',
//                         RefTPAff: '42001A',
//                         RefCT: '42001AER01',
//                         Ref: '42001AER01FR0101',
//                         TypeOperation: null
//                       }
//                     ],
//                     Comments: [
//                       {
//                         Order: 1,
//                         Text: 'Prestation réalisée avec des pièces de rechange spécialement conçues pour votre véhicule.'
//                       },
//                       {
//                         Order: 2,
//                         Text: 'Ces pièces de qualité sont testées et validées selon un cahier des charges établi par l’ingénierie Peugeot.'
//                       },
//                       {
//                         Order: 3,
//                         Text: 'Remplacement des quatre plaquettes de freins avant.'
//                       },
//                       {
//                         Order: 4,
//                         Text: "Un contrôle d'usure des disques et plaquettes de freins est effectué à chaque révision."
//                       },
//                       {
//                         Order: 5,
//                         Text: 'Ce contrôle est inclus dans notre offre pré-contrôle technique.'
//                       }
//                     ],
//                     Operations: null,
//                     isSelected: false
//                   },
//                   {
//                     Libelle: 'FORFAIT EXPERT Plaquettes de frein avant',
//                     ParentRef: '',
//                     Items: [
//                       {
//                         Libelle: '',
//                         IsAnyPgInBrr: true,
//                         IsTypeInternet: true,
//                         DateFin: '/Date(1609455600000)/',
//                         DateDebut: '/Date(1550444400000)/',
//                         Nature: 'Standard',
//                         Niveau: '08',
//                         Prix: 314,
//                         TypeDi: 'FORFAIT',
//                         TypeFdz: 'Standard',
//                         RefTPAff: '42001A',
//                         RefCT: '42001A01',
//                         Ref: '42001A01FR0101',
//                         TypeOperation: null
//                       }
//                     ],
//                     Comments: [
//                       {
//                         Order: 1,
//                         Text: 'Prestation réalisée avec des Pièces d’Origine élaborées selon le même cahier des charges que les pièces montées sur les véhicules neufs.'
//                       },
//                       {
//                         Order: 2,
//                         Text: 'Remplacement des quatre plaquettes de freins avant.'
//                       },
//                       {
//                         Order: 3,
//                         Text: "Un contrôle d'usure des disques et plaquettes de freins est effectué à chaque révision."
//                       },
//                       {
//                         Order: 4,
//                         Text: 'Ce contrôle est inclus dans notre offre pré-contrôle technique.'
//                       }
//                     ],
//                     Operations: null,
//                     isSelected: false
//                   }
//                 ]
//               }
//             ]
//           },
//           {
//             Code: 'FCT0041',
//             Title: 'Freins arrière',
//             Image: '/Media/P/fr-FR/Functions/FCT0041.jpg',
//             Order: 8,
//             Promo: false,
//             VinRequired: false,
//             isConstructeur: false,
//             hasForfait: true,
//             Price: false,
//             SubFunctionList: [
//               {
//                 Code: 'FCT0041',
//                 ForfaitList: [
//                   {
//                     Libelle: 'FORFAIT €COEXPERT Plaquettes de frein arrière',
//                     ParentRef: '',
//                     Items: [
//                       {
//                         Libelle: '',
//                         IsAnyPgInBrr: true,
//                         IsTypeInternet: true,
//                         DateFin: '/Date(1609455600000)/',
//                         DateDebut: '/Date(1550444400000)/',
//                         Nature: 'Eurorepar',
//                         Niveau: '12',
//                         Prix: 262,
//                         TypeDi: 'FORFAIT',
//                         TypeFdz: 'Standard',
//                         RefTPAff: '42002A',
//                         RefCT: '42002AER01',
//                         Ref: '42002AER01FR0101',
//                         TypeOperation: null
//                       }
//                     ],
//                     Comments: [
//                       {
//                         Order: 1,
//                         Text: 'Prestation réalisée avec des pièces de rechange spécialement conçues pour votre véhicule.'
//                       },
//                       {
//                         Order: 2,
//                         Text: 'Ces pièces de qualité sont testées et validées selon un cahier des charges établi par l’ingénierie Peugeot.'
//                       },
//                       {
//                         Order: 3,
//                         Text: 'Remplacement des quatre plaquettes de freins arrière.'
//                       },
//                       {
//                         Order: 4,
//                         Text: "Un contrôle d'usure des disques et plaquettes de freins est effectué à chaque révision."
//                       },
//                       {
//                         Order: 5,
//                         Text: 'Ce contrôle est inclus dans notre offre pré-contrôle technique.'
//                       }
//                     ],
//                     Operations: null
//                   },
//                   {
//                     Libelle: 'FORFAIT €COEXPERT Disques et plaquettes de frein arrière',
//                     ParentRef: '',
//                     Items: [
//                       {
//                         Libelle: '',
//                         IsAnyPgInBrr: true,
//                         IsTypeInternet: true,
//                         DateFin: '/Date(1609455600000)/',
//                         DateDebut: '/Date(1550444400000)/',
//                         Nature: 'Eurorepar',
//                         Niveau: '11',
//                         Prix: 542,
//                         TypeDi: 'FORFAIT',
//                         TypeFdz: 'Standard',
//                         RefTPAff: '42065A',
//                         RefCT: '42065AER01',
//                         Ref: '42065AER01FR0101',
//                         TypeOperation: null
//                       }
//                     ],
//                     Comments: [
//                       {
//                         Order: 1,
//                         Text: 'Prestation réalisée avec des pièces de rechange spécialement conçues pour votre véhicule.'
//                       },
//                       {
//                         Order: 2,
//                         Text: 'Ces pièces de qualité sont testées et validées selon un cahier des charges établi par l’ingénierie Peugeot.'
//                       },
//                       {
//                         Order: 3,
//                         Text: 'Remplacement du kit de deux disques et de quatre plaquettes de freins arrière.'
//                       },
//                       {
//                         Order: 4,
//                         Text: "Un contrôle d'usure des disques et plaquettes de freins est effectué à chaque révision."
//                       },
//                       {
//                         Order: 5,
//                         Text: 'Ce contrôle est inclus dans notre offre pré-contrôle technique.'
//                       }
//                     ],
//                     Operations: null
//                   },
//                   {
//                     Libelle: 'FORFAIT EXPERT Plaquettes de frein arrière',
//                     ParentRef: '',
//                     Items: [
//                       {
//                         Libelle: '',
//                         IsAnyPgInBrr: true,
//                         IsTypeInternet: true,
//                         DateFin: '/Date(1609455600000)/',
//                         DateDebut: '/Date(1550444400000)/',
//                         Nature: 'Standard',
//                         Niveau: '08',
//                         Prix: 300,
//                         TypeDi: 'FORFAIT',
//                         TypeFdz: 'Standard',
//                         RefTPAff: '42002A',
//                         RefCT: '42002A01',
//                         Ref: '42002A01FR0101',
//                         TypeOperation: null
//                       }
//                     ],
//                     Comments: [
//                       {
//                         Order: 1,
//                         Text: 'Prestation réalisée avec des Pièces d’Origine élaborées selon le même cahier des charges que les pièces montées sur les véhicules neufs.'
//                       },
//                       {
//                         Order: 2,
//                         Text: 'Remplacement des quatre plaquettes de freins arrière.'
//                       },
//                       {
//                         Order: 3,
//                         Text: "Un contrôle d'usure des disques et plaquettes de freins est effectué à chaque révision."
//                       },
//                       {
//                         Order: 4,
//                         Text: 'Ce contrôle est inclus dans notre offre pré-contrôle technique.'
//                       }
//                     ],
//                     Operations: null
//                   },
//                   {
//                     Libelle: 'FORFAIT EXPERT Disques et plaquettes de frein arrière',
//                     ParentRef: '',
//                     Items: [
//                       {
//                         Libelle: '',
//                         IsAnyPgInBrr: true,
//                         IsTypeInternet: true,
//                         DateFin: '/Date(1609455600000)/',
//                         DateDebut: '/Date(1550444400000)/',
//                         Nature: 'Standard',
//                         Niveau: '15',
//                         Prix: 646,
//                         TypeDi: 'FORFAIT',
//                         TypeFdz: 'Standard',
//                         RefTPAff: '42065A',
//                         RefCT: '42065A01',
//                         Ref: '42065A01FR0101',
//                         TypeOperation: null
//                       }
//                     ],
//                     Comments: [
//                       {
//                         Order: 1,
//                         Text: 'Prestation réalisée avec des Pièces d’Origine élaborées selon le même cahier des charges que les pièces montées sur les véhicules neufs.'
//                       },
//                       {
//                         Order: 2,
//                         Text: 'Remplacement du kit de deux disques et de quatre plaquettes de freins arrière.'
//                       },
//                       {
//                         Order: 3,
//                         Text: "Un contrôle d'usure des disques et plaquettes de freins est effectué à chaque révision."
//                       },
//                       {
//                         Order: 4,
//                         Text: 'Ce contrôle est inclus dans notre offre pré-contrôle technique.'
//                       }
//                     ],
//                     Operations: null
//                   }
//                 ]
//               }
//             ]
//           }
//         ]
//       },
//       {
//         interventionId: 569,
//         interventionLabel: 'Climatisation',
//         codeFamilyForfait: 'FCT0347',
//         Image: '/Media/P/fr-FR/Intervention/569.png',
//         forfaits: [
//           {
//             Code: 'FCT0347',
//             Title: 'Climatisation',
//             Image: '/Media/P/fr-FR/Functions/FCT0347.jpg',
//             Order: 3,
//             Promo: false,
//             VinRequired: false,
//             isConstructeur: false,
//             hasForfait: true,
//             Price: false,
//             SubFunctionList: [
//               {
//                 Code: 'FCT0347',
//                 ForfaitList: [
//                   {
//                     Libelle: 'FORFAIT EXPERT Traitement du circuit de climatisation',
//                     ParentRef: '',
//                     Items: [
//                       {
//                         Libelle: '',
//                         IsAnyPgInBrr: true,
//                         IsTypeInternet: true,
//                         DateFin: '/Date(1609369200000)/',
//                         DateDebut: '/Date(1525384800000)/',
//                         Nature: 'Standard',
//                         Niveau: '01',
//                         Prix: 28,
//                         TypeDi: 'FORFAIT',
//                         TypeFdz: 'Standard',
//                         RefTPAff: '6410CL',
//                         RefCT: '6410CL01',
//                         Ref: '6410CL01FR0101',
//                         TypeOperation: null
//                       }
//                     ],
//                     Comments: [
//                       {
//                         Order: 1,
//                         Text: 'Nettoyage des conduits de climatisation.'
//                       },
//                       {
//                         Order: 2,
//                         Text: "Permet de maintenir les performances de la climatisation et la durée de vie de l'évaporateur."
//                       }
//                     ],
//                     Operations: null,
//                     isSelected: false
//                   },
//                   {
//                     Libelle: 'FORFAIT EXPERT Traitement assainissant de l’habitacle',
//                     ParentRef: '',
//                     Items: [
//                       {
//                         Libelle: '',
//                         IsAnyPgInBrr: true,
//                         IsTypeInternet: true,
//                         DateFin: '/Date(1609369200000)/',
//                         DateDebut: '/Date(1525384800000)/',
//                         Nature: 'Standard',
//                         Niveau: '01',
//                         Prix: 26,
//                         TypeDi: 'FORFAIT',
//                         TypeFdz: 'Standard',
//                         RefTPAff: '6400CL',
//                         RefCT: '6400CL01',
//                         Ref: '6400CL01FR0101',
//                         TypeOperation: null
//                       }
//                     ],
//                     Comments: [
//                       {
//                         Order: 1,
//                         Text: 'Assainissement du circuit de climatisation.'
//                       },
//                       {
//                         Order: 2,
//                         Text: "Il est conseillé d'effectuer cette opération tous les ans lors du changement du filtre d'habitacle."
//                       },
//                       {
//                         Order: 3,
//                         Text: "Un circuit mal entretenu favorise le développement de bactéries responsables d'allergies et de mauvaises odeurs."
//                       }
//                     ],
//                     Operations: null
//                   },
//                   {
//                     Libelle: 'FORFAIT €COEXPERT Filtre d’habitacle',
//                     ParentRef: '',
//                     Items: [
//                       {
//                         Libelle: '',
//                         IsAnyPgInBrr: true,
//                         IsTypeInternet: true,
//                         DateFin: '/Date(1609455600000)/',
//                         DateDebut: '/Date(1550444400000)/',
//                         Nature: 'Eurorepar',
//                         Niveau: '12',
//                         Prix: 84,
//                         TypeDi: 'FORFAIT',
//                         TypeFdz: 'Standard',
//                         RefTPAff: '64090A',
//                         RefCT: '64090AER01',
//                         Ref: '64090AER01FR0101',
//                         TypeOperation: null
//                       }
//                     ],
//                     Comments: [
//                       {
//                         Order: 1,
//                         Text: 'Prestation réalisée avec des pièces de rechange spécialement conçues pour votre véhicule.'
//                       },
//                       {
//                         Order: 2,
//                         Text: 'Ces pièces de qualité sont testées et validées selon un cahier des charges établi par l’ingénierie Peugeot.'
//                       },
//                       {
//                         Order: 3,
//                         Text: "Remplacement du filtre d'habitacle."
//                       },
//                       {
//                         Order: 4,
//                         Text: 'Le filtre doit être changé lors de chaque révision.'
//                       },
//                       {
//                         Order: 5,
//                         Text: "Il est conseillé de faire un traitement d'assainissement tous les ans lors du changement du filtre d'habitacle."
//                       }
//                     ],
//                     Operations: null
//                   },
//                   {
//                     Libelle: 'FORFAIT EXPERT Filtre d’habitacle à charbon actif',
//                     ParentRef: '',
//                     Items: [
//                       {
//                         Libelle: '',
//                         IsAnyPgInBrr: true,
//                         IsTypeInternet: true,
//                         DateFin: '/Date(1609455600000)/',
//                         DateDebut: '/Date(1550444400000)/',
//                         Nature: 'Standard',
//                         Niveau: '04',
//                         Prix: 106,
//                         TypeDi: 'FORFAIT',
//                         TypeFdz: 'Standard',
//                         RefTPAff: '64090A',
//                         RefCT: '64090A02',
//                         Ref: '64090A02FR0201',
//                         TypeOperation: null
//                       }
//                     ],
//                     Comments: [
//                       {
//                         Order: 1,
//                         Text: 'Prestation réalisée avec des Pièces d’Origine élaborées selon le même cahier des charges que les pièces montées sur les véhicules neufs.'
//                       },
//                       {
//                         Order: 2,
//                         Text: "Remplacement du filtre d'habitacle avec charbon actif."
//                       },
//                       {
//                         Order: 3,
//                         Text: 'Le filtre doit être changé lors de chaque révision.'
//                       },
//                       {
//                         Order: 4,
//                         Text: 'Le filtre à charbon actif a une capacité plus élevée que le filtre classique pour absorber les gaz toxiques et nocifs pour la santé.'
//                       },
//                       {
//                         Order: 5,
//                         Text: "Il est conseillé d'effectuer un traitement d'assainissement tous les ans lors du changement du filtre d'habitacle."
//                       }
//                     ],
//                     Operations: null
//                   },
//                   {
//                     Libelle: 'FORFAIT EXPERT Remplacement du filtre d’habitacle (Antiallergene)',
//                     ParentRef: '',
//                     Items: [
//                       {
//                         Libelle: '',
//                         IsAnyPgInBrr: true,
//                         IsTypeInternet: true,
//                         DateFin: '/Date(1609455600000)/',
//                         DateDebut: '/Date(1550444400000)/',
//                         Nature: 'Standard',
//                         Niveau: '03',
//                         Prix: 128,
//                         TypeDi: 'FORFAIT',
//                         TypeFdz: 'Standard',
//                         RefTPAff: '64090A',
//                         RefCT: '64090A03',
//                         Ref: '64090A03FR0101',
//                         TypeOperation: null
//                       }
//                     ],
//                     Comments: [],
//                     Operations: null
//                   },
//                   {
//                     Libelle: 'FORFAIT EXPERT Recharge climatisation',
//                     ParentRef: '',
//                     Items: [
//                       {
//                         Libelle: '',
//                         IsAnyPgInBrr: true,
//                         IsTypeInternet: true,
//                         DateFin: '/Date(1609369200000)/',
//                         DateDebut: '/Date(1525384800000)/',
//                         Nature: 'Standard',
//                         Niveau: '01',
//                         Prix: 56,
//                         TypeDi: 'FORFAIT',
//                         TypeFdz: 'Standard',
//                         RefTPAff: '6405CL',
//                         RefCT: '6405CL01',
//                         Ref: '6405CL01FR0101',
//                         TypeOperation: null
//                       }
//                     ],
//                     Comments: [
//                       {
//                         Order: 1,
//                         Text: 'Prestation réalisée avec des Pièces d’Origine élaborées selon le même cahier des charges que les pièces montées sur les véhicules neufs.'
//                       },
//                       {
//                         Order: 2,
//                         Text: 'Recharge du fluide réfrigérant dans la limite de 250 grammes.'
//                       },
//                       {
//                         Order: 3,
//                         Text: "Il est recommandé d'effectuer un bilan du circuit de climatisation avant la recharge de fluide."
//                       }
//                     ],
//                     Operations: null
//                   }
//                 ]
//               }
//             ]
//           }
//         ]
//       },
//       {
//         interventionId: 2581,
//         interventionLabel: 'Révision constructeur',
//         codeFamilyForfait: 'FCT0002',
//         Image: '/Media/P/fr-FR/Intervention/2581.png',
//         forfaits: [
//           {
//             Code: 'FCT0002',
//             Title: 'Révision constructeur',
//             Image: '/Media/P/fr-FR/Functions/FCT0002.jpg',
//             Order: 1,
//             Promo: false,
//             VinRequired: true,
//             isConstructeur: true,
//             hasForfait: true,
//             Price: false,
//             SubFunctionList: {
//               0: {
//                 Code: 'FCT0002',
//                 ForfaitList: [
//                   {
//                     Libelle: 'FORFAIT EXPERT Révision PREMIUM',
//                     ParentRef: '95R01A04FR0301',
//                     Items: [
//                       {
//                         Libelle: 'FORFAIT EXPERT Révision PREMIUM',
//                         IsAnyPgInBrr: false,
//                         IsTypeInternet: false,
//                         DateFin: '/Date(1558353460059)/',
//                         DateDebut: '/Date(1558353460059)/',
//                         Nature: 'Standard',
//                         Niveau: '24',
//                         Prix: 290,
//                         TypeDi: 'FORFAITENTRETIEN',
//                         TypeFdz: 'Standard',
//                         RefTPAff: '95R01A',
//                         RefCT: '95R01A04',
//                         Ref: '95R01A04FR0301',
//                         TypeOperation: 'SYSTEMATIQUE'
//                       }
//                     ],
//                     Comments: [
//                       {
//                         Order: 1,
//                         Text: "1Prestation réalisée avec des Pièces d’Origine élaborées selon le même cahier des charges que les pièces montées sur les véhicules neufs.2Huile 5W30 : ECONOMIE D’ENERGIE ET RESPECT DE LA NATURE répondant à la norme PSA B71 22903Huile nouvelle génération recommandée pour les véhicules équipés d’un FAP (Filtre à particules).4Adaptée aux conduites en milieu exigeant : ville, autoroute, montagne.5La Révision comprend le remplacement de l'huile moteur, du filtre à huile, du joint de bouchon, le complément du liquide lave glace, un diagnostic électronique et l'ensemble des contrôles visuels des organes de sécurité"
//                       }
//                     ],
//                     Operations: [
//                       {
//                         Libelle: 'FORFAIT EXPERT Remplacement du filtre d’habitacle (Antiallergene)',
//                         ParentRef: '',
//                         Items: [
//                           {
//                             Libelle: 'FORFAIT EXPERT Remplacement du filtre d&#8217;habitacle (Antiallergene)',
//                             IsAnyPgInBrr: false,
//                             IsTypeInternet: false,
//                             DateFin: '/Date(1558353460059)/',
//                             DateDebut: '/Date(1558353460059)/',
//                             Nature: 'Standard',
//                             Niveau: '3',
//                             Prix: 118,
//                             TypeDi: 'FORFAITENTRETIEN',
//                             TypeFdz: 'Standard',
//                             RefTPAff: '95R17A',
//                             RefCT: '95R17A04',
//                             Ref: '95R17A04FR0101',
//                             TypeOperation: 'ENTRETIEN'
//                           }
//                         ],
//                         Comments: [
//                           {
//                             Order: 1,
//                             Text: ''
//                           }
//                         ],
//                         Operations: null
//                       },
//                       {
//                         Libelle: 'FORFAIT EXPERT Filtre d’habitacle à charbon actif',
//                         ParentRef: '',
//                         Items: [
//                           {
//                             Libelle: 'FORFAIT EXPERT Filtre d&#8217;habitacle à charbon actif',
//                             IsAnyPgInBrr: false,
//                             IsTypeInternet: false,
//                             DateFin: '/Date(1558353460059)/',
//                             DateDebut: '/Date(1558353460059)/',
//                             Nature: 'Standard',
//                             Niveau: '3',
//                             Prix: 96,
//                             TypeDi: 'FORFAITENTRETIEN',
//                             TypeFdz: 'Standard',
//                             RefTPAff: '95R17A',
//                             RefCT: '95R17A02',
//                             Ref: '95R17A02FR0201',
//                             TypeOperation: 'ENTRETIEN'
//                           }
//                         ],
//                         Comments: [
//                           {
//                             Order: 1,
//                             Text: "1Prestation réalisée avec des Pièces d’Origine élaborées selon le même cahier des charges que les pièces montées sur les véhicules neufs.2Remplacement du filtre d'habitacle avec charbon actif.3Le filtre doit être changé lors de chaque révision.4Le filtre à charbon actif a une capacité plus élevée que le filtre classique pour absorber les gaz toxiques et nocifs pour la santé.5Il est conseillé d'effectuer un traitement d'assainissement tous les ans lors du changement du filtre d'habitacle."
//                           }
//                         ],
//                         Operations: null,
//                         isSelected: false
//                       },
//                       {
//                         Libelle: 'FORFAIT EXPERT Liquide de frein',
//                         ParentRef: '',
//                         Items: [
//                           {
//                             Libelle: 'FORFAIT EXPERT Liquide de frein',
//                             IsAnyPgInBrr: false,
//                             IsTypeInternet: false,
//                             DateFin: '/Date(1558353460059)/',
//                             DateDebut: '/Date(1558353460059)/',
//                             Nature: 'Standard',
//                             Niveau: '1',
//                             Prix: 60,
//                             TypeDi: 'FORFAITENTRETIEN',
//                             TypeFdz: 'Standard',
//                             RefTPAff: '95R02A',
//                             RefCT: '95R02A01',
//                             Ref: '95R02A01FR0101',
//                             TypeOperation: 'ENTRETIEN'
//                           }
//                         ],
//                         Comments: [
//                           {
//                             Order: 1,
//                             Text: ''
//                           }
//                         ],
//                         Operations: null,
//                         isSelected: false
//                       }
//                     ],
//                     isSelected: false
//                   },
//                   {
//                     Libelle: 'FORFAIT €COEXPERT Révision Huile de synthèse anti-pollution 5W30',
//                     ParentRef: '95R01A08FR0101',
//                     Items: [
//                       {
//                         Libelle: 'FORFAIT €COEXPERT Révision Huile de synthèse anti-pollution 5W30',
//                         IsAnyPgInBrr: false,
//                         IsTypeInternet: false,
//                         DateFin: '/Date(1558353460059)/',
//                         DateDebut: '/Date(1558353460059)/',
//                         Nature: 'Eurorepar',
//                         Niveau: '19',
//                         Prix: 254,
//                         TypeDi: 'FORFAITENTRETIEN',
//                         TypeFdz: 'Standard',
//                         RefTPAff: '95R01A',
//                         RefCT: '95R01A08',
//                         Ref: '95R01A08FR0101',
//                         TypeOperation: 'SYSTEMATIQUE'
//                       }
//                     ],
//                     Comments: [
//                       {
//                         Order: 1,
//                         Text: "1Prestation réalisée avec des pièces de rechange spécialement conçues pour votre véhicule.2Ces pièces de qualité sont testées et validées selon un cahier des charges établi par l’ingénierie Peugeot.3Huile 5W30 : ECONOMIE D’ENERGIE ET RESPECT DE LA NATURE4Huile nouvelle génération recommandée pour les véhicules équipés d’un FAP (Filtre à particules).5Adaptée aux conduites en milieu exigeant : ville, autoroute, montagne.6La Révision comprend le remplacement de l'huile moteur, du filtre à huile, du joint de bouchon, le complément du liquide lave glace, un diagnostic électronique et l'ensemble des contrôles visuels des organes de sécurité"
//                       }
//                     ],
//                     Operations: [
//                       {
//                         Libelle: 'FORFAIT €COEXPERT Filtre d’habitacle',
//                         ParentRef: '',
//                         Items: [
//                           {
//                             Libelle: 'FORFAIT €COEXPERT Filtre d&#8217;habitacle',
//                             IsAnyPgInBrr: false,
//                             IsTypeInternet: false,
//                             DateFin: '/Date(1558353460059)/',
//                             DateDebut: '/Date(1558353460059)/',
//                             Nature: 'Eurorepar',
//                             Niveau: '12',
//                             Prix: 74,
//                             TypeDi: 'FORFAITENTRETIEN',
//                             TypeFdz: 'Standard',
//                             RefTPAff: '95R17A',
//                             RefCT: '95R17A03',
//                             Ref: '95R17A03FR0101',
//                             TypeOperation: 'ENTRETIEN'
//                           }
//                         ],
//                         Comments: [
//                           {
//                             Order: 1,
//                             Text: "1Prestation réalisée avec des pièces de rechange spécialement conçues pour votre véhicule.2Ces pièces de qualité sont testées et validées selon un cahier des charges établi par l’ingénierie Peugeot.3Remplacement du filtre d'habitacle.4Le filtre doit être changé lors de chaque révision.5Il est conseillé d'effectuer un traitement d'assainissement tous les ans lors du changement du filtre d'habitacle.6Respecter la préconisation constructeur sur les intervalles de remplacement"
//                           }
//                         ],
//                         Operations: null
//                       }
//                     ],
//                     isSelected: false
//                   }
//                 ]
//               }
//             }
//           }
//         ]
//       },
//       {
//         interventionId: 162,
//         interventionLabel: 'Autre',
//         codeFamilyForfait: '',
//         Image: '/Media/P/fr-FR/Intervention/162.png',
//         forfaits: []
//       }
//     ],
//     commentServices: 'Comment forfait exemple',
//     personalInfos: {
//       civilityCode: 'Common_Sir',
//       firstname: 'Aziz',
//       name: 'Segaoui',
//       mail: 'azizsegaoui@gmail.com',
//       phone: '0610399914',
//       contactMode: '',
//       solutionMobilite: false,
//       offerCommercial: '',
//       offerCompany: true,
//       offerPartners: '',
//       offerOppose: false,
//       acceptLegalNotices: false,
//       withPay: false,
//       selfReceptionChoice: 'n',
//       RdvUpdated: true,
//       IdRdv: 0
//     },
//     premiumServices: [],
//     visibaleDialogId: '',
//     isEditMode: false,
//     customerAttachmentId: "",
//     UploadFiles:[],
//     dateLimitModif:"2019/04/01"
// }
{
  dealer: {},
  booking: {},
  step: 1,
  car: {},
  codePasForAnnualService: '',
  kilo: {},
  service: [],
  SelectedServices: [],
  commentServices: '',
  personalInfos: {},
  selectedDsValetPremiumServices: [],
  selectedPremiumServices: [],
  listPremiumServices:[],
  visibaleDialogId: '',
  isEditMode: false,
  customerAttachmentId: "",
  UploadFiles: [],
  dateLimitModif: "",
  selectedLat: 1,
  filterDealersBy: [],
  filterByChoice: [],
  dealersFiltred: [],
  idRdvLeads: 0
}



export default (state = defaultState, action) => {
  switch (action.type) {
    case DEALER_DETAILS:
    case BOOKING_DETAILS:
    case CURRENT_STEP:
    case CAR_INFOS:
    case SERVICES:
    case CODE_PAS_FOR_ANNUALSERVICE:
    case CAR_KILO:
    case SERVICES_SELECTED:
    case COMMENT_SERVICES:
    case PERSONEL_INFOS:
    case PREMIUM_SERVICES_DSVALET:
    case SELECTED_PREMIUM_SERVICES:
    case LIST_PREMIUM_SERVICES:
    case EDITMODE:
    case DIALOG_CONFIRMATION_CHANGE_STEP:
    case ATTACHMENTID:
    case FILES:
    case DATELIMIT:
    case SELECTED_LAT:
    case SELECTED_LONG:
    case FILTER_DEALERS_BY:
    case FILTER_BY_CHOICE:
    case DEALERS_FILTRED:
    case IDRDVLEADS:
      return { ...state, ...action }
    default:
      return state
  }
}
